import clsx from 'clsx';
import { memo } from 'react';
import LogoSvg from '../../assets/logo.svg?react';
import styles from './Logo.module.css';

interface LogoProps {
  onClick?: () => void;
  className?: string;
}

export const Logo = memo<LogoProps>(({ className, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={clsx(styles.logo, onClick && styles.clicky, className)}
    >
      <LogoSvg />
    </div>
  );
});
